import { render, staticRenderFns } from "./PasswordExpired.vue?vue&type=template&id=0f5e0f0d&"
import script from "./PasswordExpired.vue?vue&type=script&lang=js&"
export * from "./PasswordExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports